import { Box, Typography } from "@mui/material";
import { useDrag } from "react-dnd";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import { formElementTypes } from "../../../../../utils/Constant";

interface CardItem {
  id?: number;
  title: string;
  type?: string;
  startIcon?: any;
}

const cards: CardItem[] = [
  {
    id: 1,
    title: "Section",
    startIcon: <FormatListBulletedIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />,
  },
  {
    id: 2,
    title: "Text Field",
    type: formElementTypes.textField,
    startIcon: <TextFieldsIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />,
  },
  {
    id: 3,
    title: "Question",
    type: formElementTypes.openEnd,
    startIcon: <QuestionMarkIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />,
  },
  {
    id: 4,
    title: "Photo Request",
    type: formElementTypes.photoRequest,
    startIcon: <CameraAltOutlinedIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />,
  },
  {
    id: 5,
    title: "Date Picker",
    type: formElementTypes.singleDate,
    startIcon: (
      <CalendarTodayOutlinedIcon sx={{ color: "rgba(0, 0, 0, 0.6)" }} />
    ),
  },
];

export default function FormElements() {
  return (
    <Box
      sx={{
        borderRight: 1,
        px: 2,
        width: 250,
        minHeight: "100vh",
        borderColor: "#C4C4C4",
      }}
      style={{ overflow: "hidden", clear: "both" }}
    >
      <Typography sx={{ ml: 2, my: 3 }} variant="h5" fontWeight={"bold"}>
        Form Elements
      </Typography>

      {cards.map((card) => (
        <DraggableButton key={card.id} card={card} />
      ))}
    </Box>
  );
}

const DraggableButton = ({ card }: any) => {
  const [{ opacity }, drag] = useDrag(() => ({
    type: "CARD",
    item: { card: card },
    collect: (monitor: any) => ({
      opacity: monitor.isDragging() ? 0.8 : 1,
    }),
  }));
  return (
    <Box
      ref={drag}
      sx={{
        mt: 2,
        height: 40,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid #E0E0E0",
        borderRadius: 2,
        px: 1,
        opacity: opacity,
      }}
    >
      <Box display={"flex"} alignItems={"center"}>
        {card.startIcon}
        <Typography ml={1}>{card.title}</Typography>
      </Box>
      <DragIndicatorIcon sx={{ color: "rgba(0, 0, 0, 0.56)" }} />
    </Box>
  );
};
